export default "__VITE_ASSET__Dux7kDwk__"